import { render, staticRenderFns } from "./ManifiestoTransportacion.vue?vue&type=template&id=385889ff"
import script from "./ManifiestoTransportacion.vue?vue&type=script&lang=js"
export * from "./ManifiestoTransportacion.vue?vue&type=script&lang=js"
import style0 from "./ManifiestoTransportacion.vue?vue&type=style&index=0&id=385889ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports